import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/products/flute-keyed-flatlay.jpg'
import _imports_1 from '@/assets/img/products/headjoint-in-flute.jpg'
import _imports_2 from '@/assets/img/products/whistle-low-d.jpg'


const _hoisted_1 = {
  class: "projects-section",
  style: {"background":"linear-gradient(to bottom, #000 0%, #000 75%, #444 100%)"}
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = {
  class: "row gx-0 mb-5 mb-lg-0 justify-content-center",
  id: "flutes"
}
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = {
  class: "bg-black text-center h-100 project",
  style: {"border-top":"0.4rem solid #f8b406"}
}
const _hoisted_6 = { class: "d-flex h-100" }
const _hoisted_7 = {
  class: "project-text w-100 mx-auto my-auto text-center text-lg-left",
  style: {"max-width":"44rem"}
}
const _hoisted_8 = { class: "text-white-50" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = {
  class: "row gx-0 justify-content-center",
  id: "headjoints"
}
const _hoisted_11 = { class: "col-lg-6 order-lg-first" }
const _hoisted_12 = { class: "bg-black text-center h-100 project" }
const _hoisted_13 = { class: "d-flex h-100" }
const _hoisted_14 = {
  class: "project-text w-100 mx-auto my-auto text-center text-lg-right",
  style: {"max-width":"44rem"}
}
const _hoisted_15 = { class: "text-white-50" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  class: "row gx-0 mb-5 mb-lg-0 justify-content-center",
  id: "whistles"
}
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "bg-black text-center h-100 project" }
const _hoisted_20 = { class: "d-flex h-100" }
const _hoisted_21 = {
  class: "project-text w-100 mx-auto my-auto text-center text-lg-left",
  style: {"max-width":"44rem"}
}
const _hoisted_22 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CitesInfoComponent = _resolveComponent("CitesInfoComponent")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("div", { class: "product-media h-100 d-flex align-items-center justify-content-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "product-img",
              alt: "A keyed blackwood Irish flute, shown disassembled into its sections"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-white" }, "irish flutes", -1)),
                _createElementVNode("p", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Hand-turned wooden flutes in the Irish tradition, voiced by hand for a warm, responsive tone all the way through. Available keyless or keyed, with a configurable number of keys (currently up to six) and a Rudall-style bore. My preferred woods are grenadilla", -1)),
                  _createVNode(_component_CitesInfoComponent),
                  _cache[1] || (_cache[1] = _createTextVNode(" and olive; other woods are possible by arrangement. ", -1))
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _createVNode(_component_LinkComponent, {
                    "link-text": "Flute details",
                    href: "/flutes",
                    inverted: true
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-white-50" }, " · ", -1)),
                  _createVNode(_component_LinkComponent, {
                    "link-text": "contact me",
                    href: "#contact",
                    inverted: true
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("div", { class: "product-media h-100 d-flex align-items-center justify-content-center" }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "product-img",
              alt: "A wooden panacoco headjoint fitted to a silver Boehm flute"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-white" }, "boehm flute headjoints", -1)),
                _createElementVNode("p", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Wooden headjoints for modern Boehm-system concert flutes — a warmer, more colourful voice for your silver flute, without replacing the instrument. Turned from the same woods as my flutes (grenadilla", -1)),
                  _createVNode(_component_CitesInfoComponent),
                  _cache[6] || (_cache[6] = _createTextVNode(", olive, or others by arrangement) featuring a CNC-cut embouchure with manual finish, and fitted to your flute's tenon to your specification. ", -1))
                ]),
                _createElementVNode("p", _hoisted_16, [
                  _createVNode(_component_LinkComponent, {
                    "link-text": "Headjoint details",
                    href: "/headjoints",
                    inverted: true
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-white-50" }, " · ", -1)),
                  _createVNode(_component_LinkComponent, {
                    "link-text": "contact me",
                    href: "#contact",
                    inverted: true
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("div", { class: "product-media h-100 d-flex align-items-center justify-content-center" }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "product-img",
              alt: "A low D whistle in panacoco wood with aluminium sections"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "text-white" }, "whistles", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-white-50" }, " Whistles are where ironwood began, and I still build them on request — in wood, aluminium and brass, tuned in just or equal intonation, in every key. Thin-walled, tunable and voiced by hand. ", -1)),
                _createElementVNode("p", _hoisted_22, [
                  _createVNode(_component_LinkComponent, {
                    "link-text": "Whistle details",
                    href: "/whistles",
                    inverted: true
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-white-50" }, " · ", -1)),
                  _createVNode(_component_LinkComponent, {
                    "link-text": "contact me",
                    href: "#contact",
                    inverted: true
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}